export const MASTER_ANSWERS_COMPANY_ID = 59230

export const MASTER_ANSWERS_TABS = [
    { key: 'lists', label: 'Master Lists' },
    { key: 'editor', label: 'Template Editor' },
    { key: 'migration', label: 'Migration Wizard' },
]
